import "../../../styles/requests.css";
import {
  convertTo12HourPlusDateFormat,
  formatToPeso,
} from "../../../util/helperFunctions";

function ApprovalItemList({ data }) {
  const detailUrl =
    `/requests?p=view-request-detail` +
    `&t=${encodeURIComponent(data?.request_type || "")}` +
    `&r=${encodeURIComponent(data?.id || "")}` +
    `&r_url=${encodeURIComponent(window.location.href)}`;

  const rawRequestType =
    data?.request_type || "";

  const isCcar =
    rawRequestType.toUpperCase() === "CCAR";

  const requestType =
    rawRequestType.toLowerCase() === "epr"
      ? "Request"
      : rawRequestType;

  const firstName =
    data?.requester_user_detail?.first_name ||
    "";

  const lastName =
    data?.requester_user_detail?.last_name ||
    "";

  const employeeName =
    `${firstName} ${lastName}`.trim();

  const warehouse =
    data?.ccar_request?.warehouse || "N/A";

  const customerAuditReferenceNumber =
    data?.ccar_request?.reference_number ||
    "N/A";

  return (
    <a className="request-item--list-container" href={detailUrl}>
      <div className="request-item--row">
        <div className="request--item-logo">
          <i
            className="fa fa-file-text-o fa-4x"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <div className="request-ref-no">
            <h1>
              {data?.reference_id || "N/A"}
            </h1>
          </div>

          <div className="request--detail">
            <div className="request--detail-item">
              <span>Employee:&nbsp;</span>
              <span>
                {employeeName || "N/A"}
              </span>
            </div>

            <div className="request--detail-item">
              <span>
                Request Type:&nbsp;
              </span>

              <span>
                {requestType || "N/A"}
              </span>
            </div>

            <div className="request--detail-item">
              <span>Form:&nbsp;</span>

              <span>
                {data?.form_detail?.name ||
                  "N/A"}
              </span>
            </div>

            <div className="request--detail-item">
              <span>
                Date &amp; Time Requested:&nbsp;
              </span>

              <span>
                {data?.createdAt
                  ? convertTo12HourPlusDateFormat(
                      data.createdAt,
                    )
                  : "N/A"}
              </span>
            </div>

            {isCcar ? (
              <>
                <div className="request--detail-item">
                  <span>
                    Warehouse:&nbsp;
                  </span>

                  <span>{warehouse}</span>
                </div>

                <div className="request--detail-item">
                  <span>
                    Customer / Audit Reference
                    No.:&nbsp;
                  </span>

                  <span>
                    {
                      customerAuditReferenceNumber
                    }
                  </span>
                </div>
              </>
            ) : (
              <div className="request--detail-item">
                <span>
                  Total Cost:&nbsp;
                </span>

                <span>
                  {formatToPeso(
                    data?.total_cost || 0,
                  )}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="request--detail-status">
        <div
          className={`status ${
            data?.overall_approval_status
              ? "approved"
              : "pending"
          } request--item-approval-status`}
        >
          <span>
            {data?.overall_approval_status
              ? "Approved"
              : "Pending"}
          </span>
        </div>
      </div>
    </a>
  );
}

export default ApprovalItemList;